export default function (state, value) {
    state.loading = value;
}